import styled from 'styled-components';
import { ReactComponent as TertiaryIcon } from '../../assets/images/tertiary.svg';

export const ImageUploaderContainer = styled.div`
  width: 128px;
  height: 128px;
  cursor: pointer;
`;

export const Dropzone = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  object-fit: cover;
  border-radius: 50%;
  width: 100%;
  height: 128px;
`;

export const StyledTertiaryIcon = styled(TertiaryIcon)`
  position: absolute;
  right: 0;
  bottom: 0;
`;
